import React from 'react';
import useEducators from './useEducators';
import { MISSING_EDUCATOR_FIELDS } from '../../../../utils/user/MISSING_FIELDS';

export default function useIncompleteEducators(state, network, schoolStart, schoolEnd, currentTimestamp) {
  return useEducators(state, network, schoolStart, schoolEnd, {
    inactive: false,
    $or: MISSING_EDUCATOR_FIELDS.$or,
    $and: {
      $or: [
        {
          sleepingStartingAt: {
            $gte: currentTimestamp
          }
        },
        {
          sleepingEndingAt: {
            $lte: currentTimestamp
          }
        }
      ]
    }
  });
}
